
import { Global, LineSelectedSchedule, LineSelectedTask } from '../../model';
import { NewValuesFormsTasksUpdateTaskable } from './forms_tasks_update_taskable';
export class NewValuesFormsTasksUpdate {
  static set(newVal = {}, schedule: LineSelectedSchedule){
    let scheduleData = Global.getScheduleData(schedule.scheduleId);
    let task:LineSelectedTask = schedule.task();
    let taskData = schedule.taskData();
    let formData = Global.getFormTaskUpdateData();
    let responsibleValue = ''
    if(taskData.responsible_type && taskData.responsible_id){
      responsibleValue = taskData.responsible_type + '#' + taskData.responsible_id;
    }
    let taskable = NewValuesFormsTasksUpdateTaskable.set({}, schedule);
    let phase_identity = task.phaseData().identity
    newVal['forms_tasks_update'] = {
      task_id: task.taskId,
      action: formData.base_action.replace('0', task.taskId),
      phase: phase_identity,
      inputs: {
        memo: {
          value: taskData.memo
        },
        status: {
          value: taskData.status
        },
        responsible: {
          value: responsibleValue,
          text:  taskData.responsible_text,
          typeahead: {
            query: 'p=' + task.phaseData().id
          }
        },
        taskable: taskable,
        required_num: {
          value: task.orderData().required_num
        }
      }
    }
  }
}
